module.exports = __webpack_public_path__ + "img/alessandro.45bb582b.webp";